/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React from 'react';
import { FC } from 'react';
import { Box, Divider, makeStyles } from '@material-ui/core';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store';
import { TEMPLATES_TRACKING_EDITOR } from 'src/constants/templates';
import Check from 'src/components/Icon/Check';
import {
  editButton1,
  editButton2,
  editCurrentButton
} from 'src/store/modules/trackings';
import AboutButtonTooltip from 'src/components/AboutButtonOneTwoTooltip';

const useStyles = makeStyles(() => ({
  wrapper: {
    width: '280px',
    minWidth: '280px',
    height: '100%',
    position: 'relative',
    backgroundColor: '#FFFFFF',
    borderRadius: '20px',
    overflow: 'hidden',
    border: '1px solid #E5E8EB'
  },

  title: {
    height: '56px',
    padding: '0 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#191F28',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E5E8EB'
  },
  divider: {
    margin: '0 16px',
    background: '#E5E8EB'
  },

  scroll: {
    height: 'calc(100% - 56px)',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    overflow: 'auto',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  menuWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  slideWrapper: {
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#191F28',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    letterSpacing: '0.02em',
    backgroundColor: '#F2F3F5',
    borderRadius: '8px'
  },
  menu: {
    height: '36px',
    padding: '0 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#191F28',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 500,
    backgroundColor: '#F7F8FA',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#F2F3F5'
    }
  },
  iconWrapper: {
    width: '24px',
    height: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E8EB',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#F2F3F5'
    }
  },

  buttonWrapper: {
    width: '48px',
    height: '120px',
    lineHeight: '120%',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: '#191F28',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: 600,
    writingMode: 'vertical-rl',
    textOrientation: 'upright',
    borderRadius: '0 16px 16px 0',
    backgroundColor: '#F2F3F5',
    border: '1px solid #E5E8EB',
    borderLeft: 'none',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#E5E8EB'
    }
  }
}));

const NavLeft: FC = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const currentTemplate = useSelector(
    (state: RootState) => state.template.templateTitle
  );

  const currentButton = useSelector(
    (state: RootState) => state.trackings.currentButton
  );
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const text = useSelector((state: RootState) => state.editText.text);
  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);
  const btnType = useSelector((state: RootState) => state.buttons.btnType);
  const switchImageType = useSelector(
    (state: RootState) => state.switchButton.switchImageType
  );

  const len =
    bgImage?.multi_background?.length ||
    bgImage?.multi_image?.length ||
    text?.multi_text?.length;

  const checkShow = (type, idx) => {
    const BUTTON = currentButton === 0 ? button1 : button2;
    const isExistType = BUTTON?.hasOwnProperty(type);
    if (isExistType) {
      const isExistValue = BUTTON?.[type]?.indexOf(Number(idx)) !== -1;
      return isExistValue;
    }
    return false;
  };
  const checkShow2 = (type, currentIndex, idx) => {
    const BUTTON = currentButton === 0 ? button1 : button2;
    const isExistType = BUTTON?.hasOwnProperty(type);
    if (isExistType) {
      const isExistValue =
        BUTTON?.[type]?.[currentIndex]?.indexOf(Number(idx)) !== -1;
      return isExistValue;
    }
    return false;
  };

  const editButton = newData => {
    if (currentButton === 0) {
      dispatch(editButton1({ ...button1, ...newData }));
    } else {
      dispatch(editButton2({ ...button2, ...newData }));
    }
  };
  const handleCheck = (type, idx) => {
    const BUTTON = currentButton === 0 ? button1 : button2;

    const isExistType = BUTTON?.hasOwnProperty(type);
    if (isExistType) {
      const newButtons = BUTTON?.[type]?.slice();
      const isExistCheck = checkShow(type, idx);
      if (isExistCheck) {
        const isExistIndex = BUTTON?.[type]?.indexOf(Number(idx));
        newButtons.splice(isExistIndex, 1);
      } else {
        newButtons.push(idx);
      }

      const newButton = JSON.parse(
        `{"${type}": [${newButtons?.map((_: any, idx: number) => {
          const newB = newButtons?.[idx];
          return `${newB}`;
        })}]}`
      );
      editButton(newButton);
    } else {
      const newButton = JSON.parse(`{"${type}": [${idx}]}`);
      editButton(newButton);
    }
  };
  const handleCheck2 = (type, currentIndex, idx) => {
    const BUTTON = currentButton === 0 ? button1 : button2;

    const isExistType = BUTTON?.hasOwnProperty(type);
    if (isExistType) {
      const newButtons = BUTTON?.[type]?.[currentIndex]?.slice();
      const isExistCheck = checkShow2(type, currentIndex, idx);
      if (isExistCheck) {
        const isExistIndex = BUTTON?.[type]?.[currentIndex]?.indexOf(
          Number(idx)
        );
        newButtons.splice(isExistIndex, 1);
      } else {
        newButtons.push(idx);
      }

      const newButtonJson = BUTTON?.[type]?.slice();
      newButtonJson.splice(currentIndex, 1, newButtons);

      const newButton = JSON.parse(
        `{"${type}": [${newButtonJson?.map(
          (buttons: any) => `[${buttons?.map((button: any) => `${button}`)}]`
        )}]}`
      );
      editButton(newButton);
    } else {
      const newButton = JSON.parse(
        `{"${type}": [${tracking?.multi_action_survey?.map(
          (data: any, optionIdx: number) =>
            currentIndex === optionIdx ? `[${idx}]` : '[]'
        )}]}`
      );
      editButton(newButton);
    }
  };

  return (
    <>
      <Box className={classes.wrapper}>
        <Box className={classes.title}>
          BUTTON LIST
          <AboutButtonTooltip />
        </Box>
        <Divider classes={{ root: classes.divider }} />
        <Box className={classes.scroll}>
          {[...Array(len)]?.map((_: any, idx: number) => (
            <Box key={idx} className={classes.menuWrapper}>
              <Box className={classes.slideWrapper}>
                Slide
                {idx + 1}
              </Box>
              {TEMPLATES_TRACKING_EDITOR?.[currentTemplate]
                ?.filter(type => {
                  if (currentTemplate === 'CHOICE BUTTON MODAL') {
                    const filterKeys =
                      btnType === 'double'
                        ? ['image_button']
                        : ['image_left_button', 'image_right_button'];
                    return !filterKeys.includes(type);
                  }
                  if (currentTemplate === 'CHOICE OPTION IMAGE') {
                    const filterKeys =
                      switchImageType === 'double'
                        ? [
                            'top_left_image_button',
                            'top_right_image_button',
                            'bottom_left_image_button',
                            'bottom_right_image_button'
                          ]
                        : ['top_image_button', 'bottom_image_button'];
                    return !filterKeys.includes(type);
                  }
                  return true;
                })
                .map(
                  (type: any) =>
                    TEMPLATES_TRACKING_EDITOR?.[currentTemplate] &&
                    tracking?.[type]?.map(
                      (data: any, idx3: number) =>
                        idx === idx3 &&
                        (Array.isArray(data) ? (
                          data?.map((data2: any, idx4: number) => (
                            <Menu2
                              key={`${type}-${idx3}-${idx4}`}
                              currentIndex={idx3}
                              idx={idx4}
                              type={type}
                              data={data2}
                              Fn={{ handleCheck2, checkShow2 }}
                            />
                          ))
                        ) : (
                          <Menu
                            key={`${type}-${idx3}`}
                            idx={idx3}
                            type={type}
                            data={data}
                            Fn={{ handleCheck, checkShow }}
                          />
                        ))
                    )
                )}
            </Box>
          ))}
        </Box>
      </Box>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {[...Array(2)].map((_: any, idx: number) => (
          <Box
            key={idx}
            className={classes.buttonWrapper}
            style={{
              top: `calc(7.5 * ${idx}rem)`,
              backgroundColor: currentButton === idx ? '#191F28' : '#F2F3F5',
              color: currentButton === idx ? '#FFFFFF' : '#191F28',
              borderColor: currentButton === idx ? '#191F28' : '#E5E8EB'
            }}
            onClick={() => {
              dispatch(editCurrentButton(idx));
            }}
          >
            BUTTON
            {idx + 1}
          </Box>
        ))}
      </div>
    </>
  );
};

export default NavLeft;

const Menu2 = ({ currentIndex, idx, type, data, Fn }: any) => {
  const classes = useStyles();

  return (
    <Box key={idx} className={classes.menu}>
      {data}
      <Box
        className={classes.iconWrapper}
        onClick={() => Fn.handleCheck2(type, currentIndex, idx)}
      >
        <Check
          stroke={Fn.checkShow2(type, currentIndex, idx) ? '#000' : '#fff'}
        />
      </Box>
    </Box>
  );
};

const Menu = ({ idx, type, data, Fn }: any) => {
  const classes = useStyles();

  return (
    <Box key={idx} className={classes.menu}>
      {data}
      <Box
        className={classes.iconWrapper}
        onClick={() => Fn.handleCheck(type, idx)}
      >
        <Check stroke={Fn.checkShow(type, idx) ? '#000' : '#fff'} />
      </Box>
    </Box>
  );
};
